module.exports = __webpack_public_path__ + "static/media/loceker_coin.76236c2d.png";